const sampleCategoryData = [
  {
    category: 'engineering',
    employmentGrowth: 8.3,
    jobs2016: 1681,
    futureJobs: [
      'Time Modification Expert',
      'Space Train Conductor',
      'Robot Designer',
    ],
  },
  {
    category: 'quality control',
    employmentGrowth: 11.8,
    jobs2016: 76,
    futureJobs: [
      'Teleportation Tester',
      'Jet Pack Inspector',
      'Robot Fight Referee',
    ],
  },
  {
    category: 'sales',
    employmentGrowth: 2.9,
    jobs2016: 15748,
    futureJobs: [
      'Traveling Jet-Pack Sales',
      'Space Tourism Agent',
      'Pre-Owned Rocket Sales',
    ],
  },
  {
    category: 'information technology',
    employmentGrowth: 13.7,
    jobs2016: 4419,
    futureJobs: [
      'Flux Capacitor Diagnostics',
      'Augmented Reality Architect',
      'Autonomous Flight Developer',
    ],
  },
  {
    category: 'social services',
    employmentGrowth: 14.5,
    jobs2016: 2571,
    futureJobs: [
      'Human-Robot Arbitrator',
      'Alien Guidance Counselor',
      'Underwater Community Development',
    ],
  },
  {
    category: 'purchasing',
    employmentGrowth: -4.8,
    jobs2016: 446.5,
    futureJobs: [
      'Adamantium Procurement',
      'Vibranium Sourcing Agent',
      'Moon Rock Distributor',
    ],
  },
  {
    category: 'business',
    employmentGrowth: 9.4,
    jobs2016: 5081,
    futureJobs: [
      'Adamantium Procurement',
      'Moon Tour Entrepreneur',
      'Chief Cyborg Officer',
    ],
  },
  {
    category: 'customer service',
    employmentGrowth: 5.3,
    jobs2016: 5830,
    futureJobs: [
      'Human-Android Liaison',
      'Space Elevator Service',
      'Chief Cyborg Officer',
    ],
  },
  {
    category: 'athletics',
    employmentGrowth: 12.3,
    jobs2016: 309,
    futureJobs: [
      'Venetian Volleyball Coach',
      'Battle Bots Competitor',
      'Space Race Agent',
    ],
  },
  {
    category: 'agriculture',
    employmentGrowth: -0.1,
    jobs2016: 1060,
    futureJobs: [
      'Urban Agriculturalist',
      'Martian Terraform Specialist',
      'Drone Harvester Sales',
    ],
  },
  {
    category: 'marketing',
    employmentGrowth: 8.5,
    jobs2016: 709,
    futureJobs: [
      'PR Manager - Galactic Alliance',
      'Viral Marketing Immunologist',
      'Manager @Pluto is a Planet, Inc.',
    ],
  },
  {
    category: 'legal',
    employmentGrowth: 9.1,
    jobs2016: 1283,
    futureJobs: [
      'Cyborg-Rights Attorney',
      'Interplanetary Compliance Specialist',
      'Attorney General - Northeast Jupiter',
    ],
  },
  {
    category: 'military',
    employmentGrowth: -3,
    jobs2016: 2082,
    futureJobs: [
      'Commander USS Enterprise',
      'Pilot @Rebel Alliance',
      'Lieutenant: Martian Drone War',
    ],
  },
  {
    category: 'government',
    employmentGrowth: 7,
    jobs2016: 2711,
    futureJobs: [
      'Alternative Currency Regulator',
      'Global System Architect',
      'Emperor of the Galactic Senate',
    ],
  },
  {
    category: 'maintenance',
    employmentGrowth: 6.6,
    jobs2016: 5905,
    futureJobs: [
      '3D Printer Service',
      'Wind Turbine Repair',
      'Astromech Droid Polisher',
    ],
  },
  {
    category: 'religion',
    employmentGrowth: 7.7,
    jobs2016: 444,
    futureJobs: ['Space Pope', 'Jedi Master', 'Robot Devil'],
  },
  {
    category: 'research',
    employmentGrowth: 23.2,
    jobs2016: 595,
    futureJobs: [
      'Memory Augmentation Scientist',
      'Jet-Pack Development',
      'Nano-Bot R&D',
    ],
  },
  {
    category: 'health care',
    employmentGrowth: 15.3,
    jobs2016: 8751,
    futureJobs: [
      'Cyborg Physician',
      'Octogenarian Service Providers',
      'Organ Cloning Specialist',
    ],
  },
  {
    category: 'finance',
    employmentGrowth: 10,
    jobs2016: 2986,
    futureJobs: [
      'Alt. Currency Financier',
      'Asteroid Security Trader',
      'Personal Robot Mortgage Broker',
    ],
  },
  {
    category: 'real estate',
    employmentGrowth: 5.6,
    jobs2016: 443,
    futureJobs: [
      'Beach-Front Property Sales (Oklahoma)',
      'Interplanetary Property Specialist',
      'Undersea Community Agent',
    ],
  },
  {
    category: 'management',
    employmentGrowth: 8.5,
    jobs2016: 9533,
    futureJobs: [
      'Big Data Warehouse Manager',
      'Jedi Master',
      'Asteroid Harvesting Lead',
    ],
  },
  {
    category: 'education',
    employmentGrowth: 9.4,
    jobs2016: 9426,
    futureJobs: [
      'Steppingblocks Neural Net Developer',
      'Course Upload Manager',
      'ESOL Teacher (Earth to Space Oriented Learning)',
    ],
  },
  {
    category: 'design',
    employmentGrowth: 6.1,
    jobs2016: 2772,
    futureJobs: [
      'Moon Colony Designer',
      'Augmented Reality Architect',
      'Humanized Bionic Designer',
    ],
  },
  {
    category: 'banking',
    employmentGrowth: 10,
    jobs2016: 2986,
    futureJobs: [
      'Alternative Currency Banker',
      'Interplanetary Currency Broker',
      'Cryptographic Banking Consultant',
    ],
  },
  {
    category: 'transportation',
    employmentGrowth: 6.2,
    jobs2016: 10274,
    futureJobs: [
      'Interplanetary Uber Driver',
      'Time Machine Operator',
      'Pilot - Imperial Starfleet',
    ],
  },
  {
    category: 'logistics',
    employmentGrowth: 6.9,
    jobs2016: 149,
    futureJobs: [
      'Teleportation Strategist',
      'Interplanetary Distribution Manager',
      'Comet Mining Analyst',
    ],
  },
  {
    category: 'other',
    employmentGrowth: 2.9,
    jobs2016: 5817,
    futureJobs: [
      'Protocol Droid Repairman',
      'Space Cartographer',
      'Robot-Chicken Farmer',
    ],
  },
  {
    category: 'science',
    employmentGrowth: 27.9,
    jobs2016: 181,
    futureJobs: [
      'Time Manipulation Scientist',
      'Evil Super Villain',
      'Officer',
    ],
  },
  {
    category: 'accounting',
    employmentGrowth: -0.2,
    jobs2016: 3336,
    futureJobs: [
      'Interstellar Tax Associate',
      'H & R Blockchain Representative',
      'Fraud Identification Quant',
    ],
  },
  {
    category: 'executive',
    employmentGrowth: 7.8,
    jobs2016: 2627,
    futureJobs: [
      'Chief Astronautical Officer',
      'Director Robotic Outreach',
      'Vice Chancellor Galactic Federation',
    ],
  },
  {
    category: 'admin clerical',
    employmentGrowth: -4.8,
    jobs2016: 3990,
    futureJobs: [
      'Teleportation Assistant',
      'Interstellar Mail Clerk',
      'Time Travel Administrator',
    ],
  },
  {
    category: 'insurance',
    employmentGrowth: 9.7,
    jobs2016: 918,
    futureJobs: [
      'Rocket Appraiser',
      'Drone Insurance Processor',
      'Teleportation Actuary',
    ],
  },
  {
    category: 'skilled labor trades',
    employmentGrowth: 6.7,
    jobs2016: 3796,
    futureJobs: [
      'Robot Polisher',
      'Subterranean Drill Operator ',
      'Asteroid Miner',
    ],
  },
  {
    category: 'human resources',
    employmentGrowth: 5.2,
    jobs2016: 631,
    futureJobs: [
      'Astronaut Recruiter',
      'Turing-Test Interviewer',
      'Galactic Compliance Officer',
    ],
  },
  {
    category: 'retail',
    employmentGrowth: 2.1,
    jobs2016: 10891,
    futureJobs: ['Space Suit Consultant', 'Laser Demonstrator'],
  },
  {
    category: 'hospitality',
    employmentGrowth: 4.4,
    jobs2016: 16176,
    futureJobs: ['Intergalactic B&B Proprietor', 'Food Synthesizer Operator'],
  },
  {
    category: 'food services',
    employmentGrowth: 3.7,
    jobs2016: 823,
    futureJobs: [
      'Food Synthesizer',
      'Zero-Gravity Waiter',
      'Intergalactic Caterer',
    ],
  },
  {
    category: 'manufacturing',
    employmentGrowth: 5.2,
    jobs2016: 1813,
    futureJobs: [
      'Zero-Gravity Woodworking',
      'Drone Manager',
      'Remote Drill Operator',
    ],
  },
  {
    category: 'construction',
    employmentGrowth: 11,
    jobs2016: 6812,
    futureJobs: ['Zero-Gravity Plumber', 'Radiation Shield Installer'],
  },
  {
    category: 'media',
    employmentGrowth: 6.1,
    jobs2016: 2773,
    futureJobs: ['Space News Anchor', 'Interstellar Broadcasting Specialist'],
  },
  {
    category: 'law enforcement',
    employmentGrowth: 5.1,
    jobs2016: 808,
    futureJobs: ['Robocop', 'Storm Trooper', 'Padawan'],
  },
  {
    category: 'entertainment',
    employmentGrowth: 6.1,
    jobs2016: 2773,
    futureJobs: ['Zero-Gravity Thespian', 'Martian Historical Actor'],
  },
]

export default sampleCategoryData



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/static/CategoryData.js